import React, { Component } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import Grid from '@material-ui/core/Grid';

import { move, reorder, movedIndexInc } from './_dndlogic.js';
import ExerciseCollection from './ExerciseCollection';
import Sandbox from './Sandbox';
import EditCircuitModal from './EditCircuitModal';
import EditPlanModal from './EditPlanModal';
import BlockDetailsModal from './BlockDetailsModal';
import SaveOrCancel from '../SaveOrCancel';
import { paginationLimit } from './../../helpers.js'

export default class Builder extends Component {

	state = {
		draggingItem: null,
		showBlockId: 0,
		selected: [],
		filter: {
			library: 'trainerExercises',
			equipmentId: 0,
			categoryId: 0,
			blockCategoryId: 0
		},
		editItemId: 0,
		isExerciseFilter: true
	};
	
	componentDidMount() {
		this.loadSandboxDefaults();
		const { library } = this.props.exerciseStoreFilter;
		this.setState({
			filter: {
				...this.state.filter,
				library: library
			}
		})
	}
	componentDidUpdate(prevProps) {
		if (this.props.editWorkout) {
			if (prevProps.editWorkout.id !== this.props.editWorkout.id) {
				this.loadSandboxDefaults();
			}
		}
	}

	getCirPlan(plans, planId, seq) {
		return Object.values(plans).filter((plan) => (Number(plan.planId) === Number(planId) && Number(plan.circuitId) === Number(seq.childId)))[0];
	}

	loadSandboxDefaults() {
		const { editWorkout } = this.props;
      	if (editWorkout) {
			let newSelects = [];
			const { sequences, plans, circuits } = editWorkout.info;
			for (var sequenceId in sequences) {
				if (sequences.hasOwnProperty(sequenceId)) {
					let seq = sequences[sequenceId];
					if (seq.child === 'plan') {
						let plan = Object.values(plans).filter((plan) => Number(plan.planId) === Number(seq.childId) && plan.circuitId === undefined)[0];
						if (plan) {
							let planData = { ...plan };
							planData.exercise = undefined;
							let seg = {
								type: 'plan',
								id: 'edit-' + seq.sequenceId,
								added: true,
								content: plan.exercise[0].name,
								data: {
									...plan.exercise[0]
								},
								formData: {
									...planData,
									planId: undefined,
									circuitId: undefined
								}
							}
							newSelects.push(seg);
						}
					} else if (seq.child === 'circuit') {
						let circuit = Object.values(circuits).filter((circuit) => Number(circuit.circuitId) === Number(seq.childId))[0];
						let circuitData = circuit;
						let cirStart = {
							child: "circuit-end-edit-" + seq.sequenceId,
							content: "Circuit Start",
							formData: {
								amrp: circuitData.amrp,
								rounds: circuitData.rounds,
								emom: circuitData.emom,
							},
							id: "circuit-start-edit-" + seq.sequenceId,
							type: "circuit",
							isEdit: true,
							added: true
						};

						newSelects.push(cirStart);
						let planIds = (typeof circuitData.planIds === 'string') ? circuitData.planIds.split(',') : circuitData.planIds;
						for (var i = 0; i < planIds.length; i++) {
							let cirPlan = this.getCirPlan(plans, planIds[i], seq)
							if (cirPlan) {
								let planData = { ...cirPlan }
								planData.exercise = undefined;
								let seg = {
									type: 'plan',
									id: 'edit-cir-plan-' + seq.childId + '-' + i,
									added: true,
									content: cirPlan.exercise && cirPlan.exercise[0].name,
									data: {
										...cirPlan.exercise[0]
									},
									formData: {
										...planData,
										planId: undefined,
										circuitId: undefined
									},
									cirStartId: cirStart.id,
									inCircuit: true
								}
								newSelects.push(seg);
							}
						}
						let cirEnd = {
							parent: "circuit-start-edit-" + seq.sequenceId,
							content: "Circuit End",
							id: "circuit-end-edit-" + seq.sequenceId,
							type: "circuit"
						};

						newSelects.push(cirEnd);
					} else if (seq.child === 'block') {
						let blockData = this.props.blocks[seq.childId];
						newSelects.push({
							content: blockData && blockData.name,
							data: {
								...blockData
							},
							id: 'block-edit-' + seq.sequenceId,
							inCircuit: false,
							type: 'block'
						})
					}
				}
			}
			this.setState({
				...this.state,
				selected: newSelects
			})
		}
	}
	id2List = {
		droppable: 'items',
		dropDestination: 'selected'
	};

	onDragEnd = result => {
		const {
			source,
			destination
		} = result;
		// dropped outside the list
		if (!destination) {
			return;
		}
		if (source.droppableId === destination.droppableId) {
			const newSelected = reorder(this.state.selected, source.index, destination.index);
			if (source.droppableId === 'dropDestination') {
				this.setState({ selected: newSelected });
			}
		} else {
			this.moveToSandbox(source, destination);
		}
	};

	toggleExerciseFavourite = (param) => {
		this.props.toggleExerciseFavourite(param);
	}

	moveToSandbox(source, destination) {
		const result = move(this.getCollectionItems(), this.state.selected, source, destination);
		if (!result) {
			return;
		}
		const movedItem = result.dropDestination[destination.index];
		// const editId =
		const editId = (movedItem.parent) ? 0 : movedItem.id;
		this.setState({
			items: result.droppable,
			selected: result.dropDestination,
			editItemId: editId
		});
	}

	
	removeItem(target) {
		let removeKids = false;
		const newList = this.state.selected.filter((item) => {
			if (target.id === item.id) {
				if (item.child) {
					removeKids = true;
				}
				return false;
			}
			if (removeKids && item.parent === target.id) {
				removeKids = false;
				return false;
			}
			if (removeKids) return false;
			return true;
		});
		this.props.saveExerciseStatus(newList.length > 0 ? true : false);
		setTimeout(() => this.setState({ selected: newList }), 0);
	}

	makeid(length) {
    let result = '';
    const characters = '0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
	}

	copyItem(target) {
		const findItem = this.state.selected.find((item) => target.id === item.id);
		if(findItem) {
			const lastIndex= target.id.lastIndexOf("-");
			const mapS= target.id .slice(0,lastIndex+1);
			const makeid = this.makeid(12)
			const findIndex = this.state.selected.findIndex((item) => target.id === item.id);
			const updateItem = {
				...findItem,
				id: `${mapS}${makeid}`
			}
			const updatedSelected = [...this.state.selected];
			updatedSelected.splice(findIndex+1, 0, updateItem)
			setTimeout(() => this.setState({ selected: updatedSelected }), 0);
			movedIndexInc();
		
		}
	}


	fetchMore = (query, isExerciseFilter) => {
		const { user } = this.props;
		if (query.library === 'trainerExercises' || !isExerciseFilter) {
			query['creatorId'] = user._id
		}
		if (query.library === 'favExercises' || !isExerciseFilter) {
			query['trainerId'] = user._id
			query['isMyfavourite'] = true
		}
		if (query.library === 'corporateExercises') {
			query['creatorType'] = 'brand'
		}
		if (isExerciseFilter) {
			delete query.blockCategoryId;
		}
		if(query.equipmentId === 0) {
			delete query.equipmentId;
		}
		if(query.categoryId === 0) {
			delete query.categoryId;
		}
		if(query.blockCategoryId === 0) {
			delete query.blockCategoryId;
		}
		if(this.props.searchTerm !== '') {
			query.search = this.props.searchTerm
		}
		if(query.categoryId && query.categoryId !== 0) {
			query.partId = query.categoryId;
			delete query.categoryId;
			delete query.blockCategoryId;
		}
		if(query.blockCategoryId && query.blockCategoryId!== 0) {
			query.categoryId = query.blockCategoryId;
			delete query.blockCategoryId;
			delete query.partId;
		}
		query.limit = 10;
		delete query.library;
		if (query.skip === 0) {
			this.props.resetExercises();
			this.props.resetBlocks();
		} 
		if (isExerciseFilter) {
			this.props.fetchMoreExercise(query)
		} else {
			this.props.fetchMoreBlock(query)
		}
	}

	getCollectionItems() {
		let items = [];
		const { equipment, categories, user } = this.props;
		const collectionFilter = this.state.filter;
		switch (collectionFilter.library) {
			case 'trainerExercises':
				items = Object.values(this.props.trainerExercises)
					.map((exercise) => {
						const mappedEquipment = equipment[exercise.equipmentId];
						const equipmentName = (mappedEquipment) ?
							mappedEquipment.name + " - " : '';
						const subtitle = categories[exercise.categoryId];
						return {
							id: exercise._id,
							content: exercise.name,
							subtitle: `${equipmentName} ${subtitle && subtitle.name}`,
							data: exercise,
							type: 'exercise'
						}
					})
				break;
			case 'favExercises': 
				items = Object.values(this.props.favExercises)
						.map((exercise) => {
							const mappedEquipment = equipment[exercise.equipmentId];
							const equipmentName = (mappedEquipment) ?
								mappedEquipment.name + " - " : '';
							const subtitle = categories[exercise.categoryId];
							return {
								id: exercise._id,
								content: exercise.name,
								subtitle: `${equipmentName} ${subtitle && subtitle.name}`,
								data: exercise,
								type: 'exercise'
							}
						})
				break;
			case 'corporateExercises':
				items = Object.values(this.props.corporateExercises)
					.map((exercise) => {
						const mappedEquipment = equipment[exercise.equipmentId];
						const equipmentName = (mappedEquipment) ?
							mappedEquipment.name + " - " : '';
						const subtitle = categories[exercise.categoryId];
						return {
							id: exercise._id,
							content: exercise.name,
							subtitle: `${equipmentName} ${subtitle && subtitle.name}`,
							data: exercise,
							type: 'exercise'
						}
					})
				break;
			case 'blocks':
				items = Object.values(this.props.blocks)
					.map((block) => {
						return {
							id: block._id,
							content: block.name,
							subtitle: ``,
							data: block,
							type: 'block'
						}
					})
				break;
			default:
				return [];
		}

		
		if (collectionFilter.equipmentId !== 0) {
			items = items.filter((item) => {
				return (item.data.equipmentId === collectionFilter.equipmentId);
			})
		}

		if (collectionFilter.categoryId !== 0) {
			items = items.filter((item) => {
				return (item.data.partId === collectionFilter.categoryId)
			})
		}

		if (collectionFilter.library === 'blocks' && collectionFilter.blockCategoryId !== 0) {
			items = items.filter((item) => {
				return (item.data.categoryId === collectionFilter.blockCategoryId)
			})
		}

		items.unshift({
			id: 'a1',
			content: 'ADD CIRCUIT ROUND',
			type: 'circuit'
		})

		return items;
	}

	handleSearch(term) {
		const filter = this.props.exerciseStoreFilter;
		this.props.setExerciseSearchTerm(term);
		let isExerciseFilter = true;
		if (this.state.filter.library === 'blocks') {
			isExerciseFilter = false;
		}
		this.fetchMore({
			skip: 0,
			...this.state.filter,
			search: term
		}, isExerciseFilter)
	}

	handleFilter(e, field) {
		let value = e.target.value;
		if (value === '0') {
			value = 0;
		}
		this.props.setExerciseFilter({
			key: field,
			value: value
		});
		let isExerciseFilter = true;
		if (value === 'blocks' || field === 'blockCategoryId') {
			isExerciseFilter = false;
		}
		if (e.target.value && field) {
			if (field === 'library' && e.target.value === 'blocks') {
				this.setState({
					filter: {
						...this.state.filter,
						[field]: value,
						blockCategoryId: 0,
						equipmentId: 0,
						categoryId: 0,
					},
					isExerciseFilter: isExerciseFilter
				}, () => {
					this.fetchMore({
						skip: 0,
						limit: paginationLimit.TEN,
						...this.state.filter,
					}, isExerciseFilter)
				})
			} else {
				let value = e.target.value;
				if (value === '0') value = Number(value);
				this.setState({
					...this.state,
					filter: {
						...this.state.filter,
						[field]: value
					},
					isExerciseFilter: isExerciseFilter
				}, () => {
					this.fetchMore({
						skip: 0,
						limit: paginationLimit.TEN,
						...this.state.filter,
					}, isExerciseFilter)			
				});
			}
		}
	}

	getEditItem() {
		const item = this.state.selected.filter((item) => {
			return item.id === this.state.editItemId;
		})
		return item[0];
	}

	getEditPlanItem() {
		let item = this.state.selected.filter((item) => {
			return item.id === this.state.editItemId;
		})
		if (item[0]) {
			const planItem = item[0];
			if (planItem.inCircuit) {
				let circuit = this.state.selected.filter((item) => {
					return item.id === planItem['cirStartId'];
				})
				if (circuit.length > 0) {
					item[0]['circuitData'] = circuit[0]['formData']
				}
			}
		}
		return item[0];
	}

	saveEditItem(details, remainOpen) {
		const target = this.getEditItem();
		const newList = this.state.selected.map((item) => {
			if (item.id === target.id) {
				if (item.data) {
					details.exerciseId = item.data._id;
					item.added = true;
				} else {
					//its probs a circuit
				}
				item.formData = details;
			}
			return item;
		})
		if (!remainOpen) {
			this.setState({
				...this.state,
				selected: newList,
				editItemId: 0
			});
			this.props.saveExerciseStatus(newList.length > 0 ? true : false);
		}

	}

	saveCircuitEditItem(details, remainOpen) {
		const target = this.getEditItem();
		const newList = this.state.selected.map((item) => {
			if (item.id === target.id) {
				if (item.data) {
					details.exerciseId = item.data._id;
					item.added = true;
				} else {
				}
				item.formData = details;
			}
			return item;
		})
		let circuit = newList.filter((item) => {
			return item.id === target.id;
		})
		for(let i = 0; i < newList.length; i++) {
			const l = newList[i];
			if (l.cirStartId === target.id) {
				if (circuit.length > 0) {
					const circuitFormData = circuit[0].formData;
					if (circuitFormData.emom !== 0) {
						l.formData.tempo = "";
					}
				}
			}
			newList[i] = l;
		}
		if (!remainOpen) {
			this.setState({
				...this.state,
				selected: newList,
				editItemId: 0
			});
		}

	}

	modifyItem(target) {
		this.setState({
			...this.state,
			editItemId: target.id
		})
	}
	showBlockDetails(blockId) {
		this.setState({
			...this.state,
			showBlockId: blockId
		})
	}

	

	
	render() {
		const { categories, equipment, validateForm, isValidating, onCancel, blockCats, isLoadMoreLibraryExercises, isLoadMoreLibraryBlocks } = this.props;
		const { filter, showBlockId, isExerciseFilter } = this.state;
		return (
			<div style={{ width: '100%', overflow: 'auto', maxHeight: 'calc(100% - 100px)' }}>
				<EditPlanModal
					save={(details) => this.saveEditItem(details)}
					item={this.getEditPlanItem()}
					close={() => { this.setState({ ...this.state, editItemId: 0 }) }}
					remove={() => this.removeItem(this.getEditPlanItem())}
				/>
				<BlockDetailsModal
					blockId={showBlockId}
					close={() => { this.setState({ ...this.state, showBlockId: 0 }) }}
				/>
				<EditCircuitModal
					save={(details) => this.saveCircuitEditItem(details)}
					item={this.getEditItem()}
					close={() => { this.setState({ ...this.state, editItemId: 0 }) }}
					remove={() => this.removeItem(this.getEditItem())}
				/>
				<DragDropContext
					onDragEnd={this.onDragEnd}
				>
					<Grid container>
						<Grid item xs={6}
							style={{
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'space-between'
							}}>
							<ExerciseCollection
								setDraggingItem={(item) => this.setState({ ...this.state, draggingItem: item })}
								blocks={this.props.blocks}
								parentType={this.props.type}
								library={filter.library}
								categories={categories}
								blockCats={blockCats}
								equipment={equipment}
								equipmentId={filter.equipmentId}
								categoryId={filter.categoryId}
								blockCategoryId={filter.blockCategoryId}
								changeSearch={(e) => this.handleSearch(e)}
								changeFilter={(e, filter) => this.handleFilter(e, filter)}
								showBlockDetails={(id) => this.showBlockDetails(id)}
								items={this.getCollectionItems()}
								fetchMore={this.fetchMore}
								filter={filter}
								isLoadMoreLibraryExercises = { isLoadMoreLibraryExercises}
								isLoadMoreLibraryBlocks = { isLoadMoreLibraryBlocks}
								toggleExerciseFavourite = { this.toggleExerciseFavourite }
								user = {this.props.user}
							/>
							<div style={{ padding: 10 }}>
								<SaveOrCancel
									saveDisabled={isValidating}
									onSaveClick={() => validateForm()}
									onCancelClick={() => onCancel()}
								/>
							</div>
						</Grid>
						<Grid item xs={6}>
							<Sandbox
								draggingItem={this.state.draggingItem}
								showBlockDetails={(id) => this.showBlockDetails(id)}
								edit={(target) => this.modifyItem(target)}
								id='dropDestination'
								items={this.state.selected}
								copyItem = {(target) => this.copyItem(target)} 
								remove={(target) => this.removeItem(target)} />
						</Grid>
					</Grid>
				</DragDropContext>
			</div>
		);
	}
}




// WEBPACK FOOTER //
// ./src/components/workouts/Builder.js